import { render, staticRenderFns } from "./WebCustomerServiceTool.vue?vue&type=template&id=f1ce5d46&"
import script from "./WebCustomerServiceTool.vue?vue&type=script&lang=ts&"
export * from "./WebCustomerServiceTool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports